import React from "react";
import {View, Text} from '@react-pdf/renderer';

const PrintDocumentAsCentralText = (props) => {
  const {styles} = props;
  return (
    <View style={[styles.marginT30, styles.main]}>
      <Text>Buyer(s) listed above hereby jointly and severally agrees to purchase the goods and/or services listed below, in accordance with the prices and terms described on this Specification Sheet and the front and the reverse of the accompanying CUSTOM REMODELING AGREEMENT, of which this Specification Sheet is a part.</Text>
    </View>
  )
};


export default PrintDocumentAsCentralText
